// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2JlJd","label":"Completed_label__391Is"};